const schedules = {
    'Friday, April 10, 2026': [
        {
            left: {
                session: 'Morning Symposium 1',
                title: 'Lipid Management in ACS Patients',
                presenter: [
                    { title: 'chairman', name: ['Nanang Rudy Utantyo, MD'] },
                    {
                        title: 'panelist',
                        name: ['Furqon Satria Adi Pradana, MD', 'Nanda, MD'],
                    },
                ],
            },
            right: {
                session: 'Morning Symposium 2',
                title: 'Antiplatelet in Acute Coronary Syndrome with Specific Condition',
                presenter: [
                    { title: 'chairman', name: ['M. Yusuf, MD'] },
                    {
                        title: 'panelist',
                        name: ['Endang Ratnaningsih, MD', 'Andrew Parlautan, MD'],
                    },
                ],
            },
        },
        {
            time: '08.30 - 08.45',
            left: {
                title: 'Secondary Prevention in ACS Patients: Role of Lipid Intervention',
                presenter: [{ title: 'speaker', name: ['Setyasih Anjarwani, MD'] }],
            },
            right: {
                title: 'Mechanisms of Platelet Inhibition in ACS: Translating Pharmacology into Clinical Care',
                presenter: [{ title: 'speaker', name: ['Andrianto, MD'] }],
            },
        },
        {
            time: '08.45 - 09.00',
            left: {
                title: 'The Effect of “Early” High Intensity Statin Initiation in ACS',
                presenter: [{ title: 'speaker', name: ['Vireza Pratama, MD'] }],
            },
            right: {
                title: 'Antiplatelet Therapy in ACS Requiring Anticoagulation: Finding the Right Balance',
                presenter: [{ title: 'speaker', name: ['Andhika Sitepu, MD'] }],
            },
        },
        {
            time: '09.00 - 09.15',
            left: {
                title: 'Lipid Management in ACS Patients in Indonesia: Insights From One ACS Registry',
                presenter: [{ title: 'speaker', name: ['M. Fadli, MD'] }],
            },
            right: {
                title: 'Antiplatelet Therapy in High-Bleeding Risk Settings: How Far Should We Go?',
                presenter: [{ title: 'speaker', name: ['Diah Retno Widowati, MD'] }],
            },
        },
        { time: '09.15 - 09.30', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        { time: '09.30 - 10.00', left: { title: 'Opening Ceremony' } },
        {
            time: '10.00 - 10.30',
            left: {
                session: 'Plenary Lecture',
                title: 'The Future of Acute and Intensive Cardiovascular Care: Advancing Science, Practice, and Systems of Care',
                presenter: [
                    { title: 'chairperson', name: ['Daniel PL Tobing, MD'] },
                    { title: 'speaker', name: ['Budi Yuli Setianto, MD'] },
                ],
            },
            right: null,
        },
        {
            left: {
                session: 'Morning Symposium 3',
                title: 'Invasive Strategy: ACS intervention dilemma and special population',
                presenter: [
                    { title: 'chairman', name: ['Faisal Habib, MD'] },
                    {
                        title: 'panelist',
                        name: ['Edrian Zulkarnain, MD', 'Nanang Rudy Utantyo, MD'],
                    },
                ],
            },
            right: {
                session: 'Morning Symposium 4',
                title: 'Hit Early, Heal Faster: Revisiting and Optimizing Statin Therapy in Acute Coronary Syndrome',
                presenter: [
                    { title: 'chairman', name: ['M. Fadli, MD'] },
                    { title: 'panelist', name: ['Daniel PL Tobing, MD', 'Nanda, MD'] },
                ],
            },
        },
        {
            time: '10.30 - 10.45',
            left: {
                title: 'The Beating Clock: When Is the Optimal Timing for Angiography in Non-ST Elevation Acute Coronary Syndrome?',
                presenter: [{ title: 'speaker', name: ['Dafsah Arifa Juzar, MD'] }],
            },
            right: {
                title: 'Statin pleiotropic effects beyond LDL-lowering in ACS',
                presenter: [{ title: 'speaker', name: ['Bimo Bintoro, MD'] }],
            },
        },
        {
            time: '10.45 - 11.00',
            left: {
                title: 'ACS with Multivessel Disease: Intervention Strategies in STEMI: Focus on the “Culprit” or Address All at Once?',
                presenter: [{ title: 'speaker', name: ['Isman Firdaus, MD'] }],
            },
            right: {
                title: 'Tailored Lipid Management for Asian in ASCVD: Evidence from The Rosuvastatin/Ezetimibe Combination Study',
                presenter: [{ title: 'speaker', name: ['Safir Sungkar, MD'] }],
            },
        },
        {
            time: '11.00 - 11.15',
            left: {
                title: 'Double-Edged Sword: Challenging of Invasive Strategies in special population with ACS (elderly, CKD and Diabetes)',
                presenter: [{ title: 'speaker', name: ['Ismir Fahri, MD'] }],
            },
            right: {
                title: 'What I really mean when I say MINOCA: Does Statin Important in This Population?',
                presenter: [{ title: 'speaker', name: ['Magma Purnawan Putra, MD'] }],
            },
        },
        { time: '11.15 - 11.30', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        { time: '11.30 - 13.00', all: { title: 'Lunch, Friday Prayer, and Exhibition' } },
        {
            left: {
                session: 'Lunch Symposium 1',
                title: 'Invasive and Non-Invasive Monitoring in ICCU',
                presenter: [
                    { title: 'panelist', name: ['Setyasih Anjarwani, MD', 'Elok Nurlisa Artiko, MD'] },
                ],
            },
            right: {
                session: 'Lunch Symposium 2',
                title: 'Joint Session InaACC and ESC ACVC: Acute Heart Failure & Cardiogenic Shock in ICCU',
                presenter: [
                    { title: 'chairman', name: ['Siska Suridanda Danny, MD'] },
                    { title: 'panelist', name: ['Danayu Sanni, MD', 'Safir Sungkar, MD'] },
                ],
            },
        },
        {
            time: '13.00 - 13.15',
            left: {
                title: 'Lung Ultrasound (LUS) in the ICCU: From B-Lines to Bedside Decisions',
                presenter: [{ title: 'speaker', name: ['Miftah Pramudya, MD'] }],
            },
            right: {
                title: 'From Congestion to Perfusion: Practical Hemodynamic Approach in Acute HF',
                presenter: [{ title: 'speaker', name: ['Bambang Widyantoro, MD'] }],
            },
        },
        {
            time: '13.15 - 13.30',
            left: {
                title: 'PAC vs Echo Guided Hemodynamics : Which Should Lead ?',
                presenter: [{ title: 'speaker', name: ['Vienna Rossimarina, MD'] }],
            },
            right: {
                title: 'The Chain of Survival in Cardiogenic Shock: Emphasizing Early Recognition and Management',
                presenter: [{ title: 'speaker', name: ['Faisal Habib, MD'] }],
            },
        },
        {
            time: '13.30 - 13.45',
            left: {
                title: 'Venous Congestion as a Therapeutic Target: VExUS Score in ICCU Practice',
                presenter: [{ title: 'speaker', name: ['Rony M. Candrasatria, MD'] }],
            },
            right: {
                title: 'The Role of PAC & Mechanical Support in Acute HF and Cardiogenic Shock / Current and Novel Biomarkers in Cardiogenic Shock',
                presenter: [{ title: 'speaker', name: ['Alessandro Sionis, MD'] }],
            },
        },
        { time: '13.45 - 14.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },

        // Afternoon Symposiums 1 & 2
        {
            left: {
                session: 'Afternoon Symposium 1',
                title: 'Cardiovascular Critical Care Management in Octogenarian (Joint Session with APSC / Asian Pacific Society of Cardiology)',
                presenter: [
                    { title: 'chairman', name: ['Saifur Rohman, MD'] },
                    { title: 'panelist', name: ['Bambang Widiyantoro, MD', 'Dedy Irawan, MD'] },
                ],
            },
            right: {
                session: 'Afternoon Symposium 2',
                title: 'Post Cardiac Arrest Management',
                presenter: [
                    { title: 'chairman', name: ['Magma Purnawan Putra, MD'] },
                    { title: 'panelist', name: ['Andika Sitepu, MD', 'Deo Idarto, MD'] },
                ],
            },
        },
        {
            time: '14.00 - 14.15',
            left: {
                title: 'ACS Management of Reperfusion in Octogenarian',
                presenter: [{ title: 'speaker', name: ['Tri Astiawati, MD'] }],
            },
            right: {
                title: 'Post–Cardiac Arrest Care: 2025 ACLS Update',
                presenter: [{ title: 'speaker', name: ['Dian Zamroni, MD'] }],
            },
        },
        {
            time: '14.15 - 14.30',
            left: {
                title: 'Management of Acute Heart Failure in Octogenarian',
                presenter: [{ title: 'speaker', name: ['Edrian Zulkarnain, MD'] }],
            },
            right: {
                title: 'Neuroprotection after Cardiac Arrest: Re-evaluating the Role of Therapeutic Hypothermia',
                presenter: [{ title: 'speaker', name: ['Vienna Rossimarina, MD'] }],
            },
        },
        {
            time: '14.30 - 14.45',
            left: {
                title: 'Management of Futile Patient in ICCU',
                presenter: [{ title: 'speaker', name: ['Tan Joo Hor, MD (Singapore)'] }],
            },
            right: {
                title: 'Coronary Angiography in Post-Cardiac Arrest Care: Timing the Perfect Strike',
                presenter: [{ title: 'speaker', name: ['M Rijal, MD'] }],
            },
        },
        { time: '14.45 - 15.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },

        // Afternoon Symposiums 3 & 4
        {
            left: {
                session: 'Afternoon Symposium 3',
                title: 'Bridging the Gap Between Guidelines and Clinical Practice in Acute Heart Failure: Contemporary Approaches and Real-World Challenges',
                presenter: [
                    { title: 'chairman', name: ['Andrianto, MD'] },
                    { title: 'panelist', name: ['Rio Herdyanto, MD', 'Ria Ashriyah, MD'] },
                ],
            },
            right: {
                session: 'Afternoon Symposium 4',
                title: 'Cased Based Session : Acute Heart Failure in Severe Valvular Heart Disease',
                presenter: [
                    { title: 'chairman', name: ['Setyasih Anjarwani, MD'] },
                    { title: 'panelist', name: ['Ali Sobirin, MD', 'Praise Jeremiah, MD'] },
                ],
            },
        },
        {
            time: '15.00 - 15.15',
            left: {
                title: 'Rapid Diagnosis and Phenotyping of Acute Heart Failure: What Must Be Done in the First 60 Minutes?',
                presenter: [{ title: 'speaker', name: ['Roy Christian, MD'] }],
            },
            right: {
                title: 'Double Jeopardy: Why Acute Valvular Heart Failure Should be approached Differently?',
                presenter: [{ title: 'speaker', name: ['Indra Prasetya, MD'] }],
            },
        },
        {
            time: '15.15 - 15.30',
            left: {
                title: 'Decongestion Beyond Diuretics: Innovative Strategies and Evidence from Recent Trials',
                presenter: [{ title: 'speaker', name: ['Jusup Endang, MD'] }],
            },
            right: {
                title: 'Hemodynamic Monitoring and Medical Management Strategies',
                presenter: [{ title: 'speaker', name: ['Hendy Wirawan, MD'] }],
            },
        },
        {
            time: '15.30 - 15.45',
            left: {
                title: 'Initiating SGLT2i in Heart Failure: A Hospital-Setting Approach',
                presenter: [{ title: 'speaker', name: ['Budi Yuli Setianto, MD'] }],
            },
            right: {
                title: 'Case Sharing',
                presenter: [{ title: 'speaker', name: ['Irma Maghfira, MD'] }],
            },
        },
        { time: '15.45 - 16.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
    ],
    'Saturday, April 11, 2026': [
        {
            left: {
                session: 'Morning Symposium 5',
                title: 'From ACS to CCS: which, where dan when the medication should be given for indonesian setting',
                presenter: [
                    { title: 'chairman', name: ['Roy Christian, MD'] },
                    { title: 'panelist', name: ['I Made Junior Rina Artha, MD', 'Vera Yulia, MD'] },
                ],
            },
            right: {
                session: 'Morning Symposium 6',
                title: 'Spotlight on the Right Heart Failure in the Critically Ill Cardiac Patients',
                presenter: [
                    { title: 'chairman', name: ['Irmalita, MD'] },
                    { title: 'panelist', name: ['Dian Zamroni, MD', 'Braghmandaru Adhi Bhaskara, MD'] },
                ],
            },
        },
        {
            time: '08.00 - 08.15',
            left: {
                title: 'Understanding Angina: From Pathomechanisms to Clinical Management',
                presenter: [{ title: 'speaker', name: ['Marshell Luntungan, MD'] }],
            },
            right: {
                title: 'Right Heart Cath to the rescue: Indications and practical pearls in CVCU',
                presenter: [{ title: 'speaker', name: ['I Kadek Susila Surya Darma, MD'] }],
            },
        },
        {
            time: '08.15 - 08.30',
            left: {
                title: 'Long-Acting Nitrates Across the Angina Spectrum',
                presenter: [{ title: 'speaker', name: ['Saifur Rohman, MD'] }],
            },
            right: {
                title: 'Echo First: Practical Echocardiography for RV Dysfunction and PH in CVCU',
                presenter: [{ title: 'speaker', name: ['Lita Dwi Suryani Harahap, MD'] }],
            },
        },
        {
            time: '08.30 - 08.45',
            left: {
                title: 'Comprehensive Predischarged Management After ACS',
                presenter: [{ title: 'speaker', name: ['Endang Ratnaningsih, MD'] }],
            },
            right: {
                title: 'Milrinone in the frontline: practical inotropes use for the cardiac intensivist',
                presenter: [{ title: 'speaker', name: ['Tri Astiawty, MD'] }],
            },
        },
        { time: '08.45 - 09.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        {
            left: {
                session: 'Morning Symposium 7',
                title: 'Master Complex ACS with Ovine Enoxaparin: Proven Efficacy & Optimal Safety',
                presenter: [
                    { title: 'chairman', name: ['Ismir Fahri, MD'] },
                    { title: 'panelist', name: ['Rony M. Candrasatria, MD', 'Kana Elka, MD'] },
                ],
            },
            right: {
                session: 'Morning Symposium 8',
                title: 'From Guidelines to Bedside: Bridging Evidence–Practice Gaps in managing Acute Coronary syndrome',
                presenter: [
                    { title: 'chairman', name: ['Vidya Gilang Rejeki, MD'] },
                    { title: 'panelist', name: ['Herawati Isnanjiah, MD', 'Aditya Pradhana, MD'] },
                ],
            },
        },
        {
            time: '09.00 - 09.15',
            left: {
                title: 'How to Stratify Bleeding and Ischemia Risk in ACS',
                presenter: [{ title: 'speaker', name: ['Fadillah Maricar, MD'] }],
            },
            right: {
                title: 'Beyond STEMI and NSTEMI: Embracing Occlusive MI (OMI) and non-Occlusive MI (NOMI) in Acute Coronary Syndromes',
                presenter: [{ title: 'speaker', name: ['M. Hatta, MD'] }],
            },
        },
        {
            time: '09.15 - 09.30',
            left: {
                title: 'Current Guideline and Clinical Recommendation of Anticoagulants in ACS',
                presenter: [{ title: 'speaker', name: ['Wiza Erlanda, MD'] }],
            },
            right: {
                title: 'Aligning guideline with emerging recent real-world evidence in the use of potent antiplatelet',
                presenter: [{ title: 'speaker', name: ['Safir Sungkar, MD'] }],
            },
        },
        {
            time: '09.30 - 09.45',
            left: {
                title: 'Clinical Use of Ovine Enoxaparin Sodium in the Management of ACS',
                presenter: [{ title: 'speaker', name: ['Danayu Sanni, MD'] }],
            },
            right: {
                title: 'Use of Potent Antiplatelet in ACS: From Landmark Trial to Real World Practice',
                presenter: [{ title: 'speaker', name: ['M. Yusuf, MD'] }],
            },
        },
        { time: '09.45 - 10.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        {
            left: {
                session: 'Pre-Lunch Symposium 1',
                title: 'Pulmonary Embolism in the ICCU: From Rapid Diagnosis to Advanced Hemodynamic Rescue',
                presenter: [
                    { title: 'chairman', name: ['Isman Firdaus, MD'] },
                    { title: 'panelist', name: ['Siska Suridanda Danny, MD', 'Gustaf David, MD', 'Novi Anggriyani, MD'] },
                ],
            },
            right: {
                session: 'Pre-Lunch Symposium 2',
                title: 'Managing Emergencies in Cardiac Critical Care Unit',
                presenter: [
                    { title: 'chairman', name: ['I Putu Gede Budiana, MD'] },
                    { title: 'panelist', name: ['Jusup Endang, MD', 'Corniansyah, MD'] },
                ],
            },
        },
        {
            time: '10.00 - 10.15',
            left: {
                title: 'Pulmonary Embolism : Unmasking the Silent Threat',
                presenter: [{ title: 'speaker', name: ['Adi Bestara, MD'] }],
            },
            right: {
                title: 'Time Is Muscle: Optimising Antiplatelet Therapy in Acute Coronary Syndromes',
                presenter: [{ title: 'speaker', name: ['Bambang Widyantoro, MD'] }],
            },
        },
        {
            time: '10.15 - 10.30',
            left: {
                title: 'Managing Pulmonary Embolism in Clinical Practice : From Emergency to Critical Care Unit',
                presenter: [{ title: 'speaker', name: ['Daniel PL Tobing, MD'] }],
            },
            right: {
                title: 'Managing Ventricular Tachycardia Storm in the ICCU: Escalation from Drugs to Ganglion Blockade',
                presenter: [{ title: 'speaker', name: ['Aruman Yudanto, MD'] }],
            },
        },
        {
            time: '10.30 - 10.45',
            left: {
                title: 'Targeting the Clot: Device-Based Management of Pulmonary Embolism',
                presenter: [{ title: 'speaker', name: ['Keith M. Sterling, MD (American Speaker)'] }],
            },
            right: {
                title: 'Hyperkalaemia in Cardiac Critical Care Unit : A Silent but Lethal Threat',
                presenter: [{ title: 'speaker', name: ['Fauziar Ahnaf, MD'] }],
            },
        },
        { time: '10.45 - 11.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        {
            left: {
                session: 'Lunch Symposium 3',
                title: 'Early escalation for lipid lowering therapy with Inclisiran - the ultimate game changer for ASCVD',
                presenter: [
                    { title: 'chairman', name: ['I Kadek Susila Surya Darma, MD'] },
                    { title: 'panelist', name: ['I Putu Gede Budiana, MD', ' Aditya Pradana, MD'] },
                ],
            },
            right: {
                session: 'Lunch Symposium 4',
                title: 'Beyond the Failing Heart: Comprehensive Management in Cardiogenic Shock',
                presenter: [
                    { title: 'chairman', name: ['Rien Afrianti, MD'] },
                    { title: 'panelist', name: ['Indra Prasetya, MD', 'Asa Rizka Gemilang, MD'] },
                ],
            },
        },
        {
            time: '11.00 - 11.15',
            left: {
                title: 'Strategies for Lipid-Lowering Therapy After ACS : ESC vs AHA Guidelines',
                presenter: [{ title: 'speaker', name: ['I Made Junior Rina Artha, MD'] }],
            },
            right: {
                title: 'Cracking the Code: Phenotyping is Key in Cardiogenic Shock',
                presenter: [{ title: 'speaker', name: ['Andrew Parlautan, MD'] }],
            },
        },
        {
            time: '11.15 - 11.30',
            left: {
                title: 'Beyond the pill : Inclisiran in reinventing LDL-C management in post-ACS patients',
                presenter: [{ title: 'speaker', name: ['Dafsah Arifa Juzar, MD'] }],
            },
            right: {
                title: 'Respiratory Management and Renal Support for Cardiogenic Shock Patient',
                presenter: [{ title: 'speaker', name: ['Farhanah Meutia, MD'] }],
            },
        },
        {
            time: '11.30 - 11.45',
            left: {
                title: 'Early goal attainment or long term retention : What drives better patient outcomes?',
                presenter: [{ title: 'speaker', name: ['Sodiqur Rifqi, MD'] }],
            },
            right: {
                title: 'Targeting Inflammation: A New Frontier in Managing Cardiogenic Shock?',
                presenter: [{ title: 'speaker', name: ['Hendry Purnasidha Bagaswoto, MD'] }],
            },
        },
        { time: '11.45 - 12.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        { time: '12.00 - 13.00', all: { title: 'JEOPARDY, Lunch, and Exhibition' } },
        {
            left: {
                session: 'Afternoon Symposium 5',
                title: 'Building an Integrated STEMI Network: Translating Evidence Into Daily Clinical Practice',
                presenter: [
                    { title: 'chairman', name: ['Hendry Purnasidha Bagaswoto, MD'] },
                    { title: 'panelist', name: ['Dafsah Arifa Juzar, MD', 'Praise Jeremiah, MD'] },
                ],
            },
            right: {
                session: 'Afternoon Symposium 6',
                title: 'Pulmonary Hypertension in Cardiac Intensive Care',
                presenter: [
                    { title: 'chairman', name: ['Vireza Pratama, MD'] },
                    { title: 'panelist', name: ['M Rijal, MD', 'Vidya Gilang Rejeki, MD'] },
                ],
            },
        },
        {
            time: '13.00 - 13.15',
            left: {
                title: 'STEMI Network Strategies: Lessons from the Taiwan Stent–Save a Life! Program',
                presenter: [{ title: 'speaker', name: ['David Huang, MD'] }],
            },
            right: {
                title: 'Classification of Pulmonary Hypertension in Cardiac Intensive Care',
                presenter: [{ title: 'speaker', name: ['Irmalita, MD'] }],
            },
        },
        {
            time: '13.15 - 13.30',
            left: {
                title: 'Challenges in Developing STEMI Pathways in Indonesia: Pre-Hospital to Catheterization Lab',
                presenter: [{ title: 'speaker', name: ['Indra Prasetya, MD'] }],
            },
            right: {
                title: 'How to Managed RV Failure Due To PH Crisis',
                presenter: [{ title: 'speaker', name: ['Yose Ramda Ilhami, MD'] }],
            },
        },
        {
            time: '13.30 - 13.45',
            left: {
                title: 'Outcome Measurement in STEMI Care: Based on One-ICCU Registry',
                presenter: [{ title: 'speaker', name: ['Firandi Saputra, MD'] }],
            },
            right: {
                title: 'Management in PH Crisis : Focused on Pharmacology',
                presenter: [{ title: 'speaker', name: ['Lucia Krisdinarti, MD'] }],
            },
        },
        { time: '13.45 - 14.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        {
            left: {
                session: 'Afternoon Symposium 7',
                title: 'Beyond the Obvious: Recognizing Uncommon and Overlooked Findings in the ICCU',
                presenter: [
                    { title: 'chairman', name: ['Diah Retno Widowati, MD'] },
                    { title: 'panelist', name: ['Marshell Luntungan, MD', 'Evita Devi N, MD'] },
                ],
            },
            right: {
                session: 'Afternoon Symposium 8',
                title: 'Common Conundrums in the Intensive Cardiovascular Care Unit: An Interactive Session',
                presenter: [
                    { title: 'chairman', name: ['Budi Yuli Setianto, MD'] },
                    { title: 'panelist', name: ['Bimo Bintoro, MD', 'Wiza Erlanda, MD'] },
                ],
            },
        },
        {
            time: '14.00 - 14.15',
            left: {
                title: 'Sepsis-Induced Cardiomyopathy: Recognition, Hemodynamic Impact, and Clinical Management',
                presenter: [{ title: 'speaker', name: ['Maha Fitra, MD'] }],
            },
            right: {
                title: 'Should We Give Sodium Bicarbonate for Metabolic Acidosis?',
                presenter: [{ title: 'speaker', name: ['Vidya Gilang Rejeki, MD'] }],
            },
        },
        {
            time: '14.15 - 14.30',
            left: {
                title: 'Injectable Labetalol in Hypertensive Emergencies: When and How to Use in Cardiology Practice',
                presenter: [{ title: 'speaker', name: ['Siska Suridanda Danny, MD'] }],
            },
            right: {
                title: 'Beta Blocker after Myocardial Infarction in Preserved Ejection Fraction',
                presenter: [{ title: 'speaker', name: ['Rien Afrianti, MD'] }],
            },
        },
        {
            time: '14.30 - 14.45',
            left: {
                title: 'When the Lungs Fail in the ICCU: Evidence-Based ARDS Management',
                presenter: [{ title: 'speaker', name: ['Rita Zahara, MD'] }],
            },
            right: {
                title: 'Early Pharmacological Treatment in Cardiogenic Shock: Vasodilators, Vasopressors, or Inotropes?',
                presenter: [{ title: 'speaker', name: ['Hendry Purnasidha Bagaswoto, MD'] }],
            },
        },
        { time: '14.45 - 15.00', left: { title: 'Discussion' }, right: { title: 'Discussion' } },
        { time: '15.00 - ', left: { title: 'Closing Ceremony' } },
    ],
};

export default schedules;
